var AnalyticsOrder = /** @class */ (function () {
    function AnalyticsOrder(packOmapiId, packOmapiIdPrice, subPackOmapiId, subPackOmapiIdPrice) {
        this.packOmapiIdPrice = 0;
        this.subPackOmapiIdPrice = 0;
        this.packOmapiId = packOmapiId;
        this.subPackOmapiId = subPackOmapiId;
        this.packOmapiIdPrice = packOmapiIdPrice;
        this.subPackOmapiIdPrice = subPackOmapiIdPrice;
    }
    AnalyticsOrder.prototype.totalPrice = function () {
        if (this.subPackOmapiId) {
            return this.packOmapiIdPrice + this.subPackOmapiIdPrice;
        }
        return this.packOmapiIdPrice;
    };
    return AnalyticsOrder;
}());
export { AnalyticsOrder };
